import { IconButton } from "@circleco/compass/components/IconButton";
import { Slider } from "@circleco/compass/components/Slider";
import { cloneDeep } from "lodash";

import { t } from "@/i18n-js/instance";

import type { SelectedImage } from "../../store";
import { useImagePostModalStore } from "../../store";

interface ZoomSliderProps {
  currentImage: SelectedImage;
}

export const ZoomSlider = ({ currentImage }: ZoomSliderProps) => {
  const { updateImage } = useImagePostModalStore();
  const handleSliderChange = (nextValue: number | readonly number[]) => {
    const zoom =
      typeof nextValue === "number" ? nextValue : Number(nextValue[0]);

    if (!Number.isFinite(zoom) || zoom === currentImage.zoom) return;

    updateImage({ ...cloneDeep(currentImage), zoom });
  };

  return (
    <div className="text-light flex items-center justify-between">
      <IconButton
        aria-label={t("zoom_out")}
        icon="minus"
        onClick={() => {
          const updatedImage = {
            ...cloneDeep(currentImage),
            zoom: currentImage.zoom - 0.1,
          };
          if (updatedImage.zoom >= 1) {
            updateImage(updatedImage);
          }
        }}
        className="mr-3"
        size="sm"
        type="button"
        variant="ghost"
      />
      <div className="flex h-4 w-32 items-center">
        <Slider
          value={[Math.round(currentImage.zoom * 10) / 10]}
          max={5}
          min={1}
          step={0.1}
          onValueChange={handleSliderChange}
        />
      </div>
      <IconButton
        onClick={() => {
          const updatedImage = {
            ...cloneDeep(currentImage),
            zoom: currentImage.zoom + 0.1,
          };
          if (updatedImage.zoom <= 5) {
            updateImage(updatedImage);
          }
        }}
        aria-label={t("zoom_in")}
        className="ml-3"
        icon="plus"
        size="sm"
        type="button"
        variant="ghost"
      />
    </div>
  );
};
